import { useEffect, useState } from "react";
import { HideLoder, shipStationUrlTrack, ShowLoder } from "../JS/Common";
import Popup from "./Popup";
import { ApiGetCall } from "../JS/Connector";

export default function TrackingDetailsPopup({ showModal, size = "lg", modalTitle = "Shipping Information", closePopup, BatchId = "" }) {
    const [shippingInformation, setShippingInformaton] = useState(null);
    const [loading, setLoading] = useState(false);
    const methodToCarrier = { 1: "FedEx", 2: "UPS", 3: "USPS" };

    useEffect(() => {
        getTrackShippingDetails();
    }, []);

    const getTrackShippingDetails = () => {
        setLoading(true)
        ApiGetCall(`/schools/batches/data-by-id?batchId=${BatchId}`).then((result) => {
            if (result == undefined || result == "") {
                setLoading(false);
                alert("Something went wrong");
            } else {
                const responseRs = JSON.parse(result);
                setLoading(false);
                setShippingInformaton(responseRs);
            }
        })
    }

    const modalBody = (
        <>
            <div className="row">
                <div className="col-md-12">
                    <b>Batch Name:</b> <label>{shippingInformation?.batch_name || "-"}</label>
                </div>
                <div className="col-md-12">
                    <b>Batch Notes:</b> <label>{shippingInformation?.batch_notes || "-"}</label>
                </div>
            </div>
            <div className="row mt-3">
                <div className="col-md-6">
                    <b>Carrier:</b> <label>{methodToCarrier[shippingInformation?.carrier] || "-"}</label>
                </div>
                <div className="col-md-6">
                    <b>Status: </b> <label>{shippingInformation?.status_code || "-"}</label>
                </div>
                <div className="col-md-6">
                    <b>Tracking Num: </b>
                    {shippingInformation?.tracking_num ?
                        <label className=" text-decoration-underline cursor-pointer" onClick={() => shipStationUrlTrack(shippingInformation?.tracking_url)}>
                            {shippingInformation?.tracking_num || "-"}
                        </label>
                        : <>-</>
                    }
                </div>
            </div>
            <div className="row mt-4">
                <div className="col-md-12 fs-5">
                    <b>Pickup Information</b>
                    <hr />
                </div>
                <div className="col-md-12">
                    <div className="greyBox p-3">
                        <div className="row">
                            <div className="col-md-6">
                                <b> Pickup Date: </b> <label>{shippingInformation?.pickup_date || "-"}</label>
                            </div>
                            <div className="col-md-6">
                                <b> Pickup Time: </b> <label>{shippingInformation?.pickup_time || "-"}</label>
                            </div>
                            <div className="col-md-6">
                                <b> Confirmation Num: </b> <label>{shippingInformation?.confirmation_number || "-"}</label>
                            </div>
                            <div className="col-md-6">
                                <b> Building: </b> <label>{shippingInformation?.pickup_building || "-"}</label>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
    return (
        <>
            {loading ? <ShowLoder /> : <HideLoder />}
            <Popup isshow={showModal} size={size} title={modalTitle}
                closePopup={closePopup} modalBody={modalBody} visibleSaveBtn={false} />
        </>
    )
}